export default class EventoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, EventoService, Evento, EventoOrganizacao, EventoTipo, Abrangencia, Papel, Investigador, Impacto, ImpactoOds, Ods, Pais) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.EventoService = EventoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Evento = Evento;
    this.EventoOrganizacao = EventoOrganizacao;
    this.EventoTipo = EventoTipo;
    this.Abrangencia = Abrangencia;
    this.Papel = Papel;
    this.Investigador = Investigador;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optOrganizacao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.organizadores = null;
    this.organizadoresLoading = true;

    // Default opt state - populate later when we have all states
    this.optImpactosOds = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.impactosOds = null;
    this.impactosOdsLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Evento.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'eventoTipo', 'abrangencia', 'papel', 'responsavel', 'impacto', {
          relation: 'organizacao',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getImpactosOdsForImpacto(); // We can only load this after getting impactoId
      this.getOrganizadoresForEvento();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.evento.list');
      this.UI.addToast('Erro ao carregar evento. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.Papel.find({}).$promise.then(papeis => {
        this.Abrangencia.find({}).$promise.then((abrangencias) => {
          this.EventoTipo.find({}).$promise.then((eventosTipo) => {
            wait.close();
            let options = {
              size: 'lg',
              template: require('./details.dialog.html'),
              controller: ['$scope', '$dialog', ($scope, $dialog) => {
                $scope.label = "Editar Evento";
                $scope.evento = angular.copy(this.data);
                $scope.eventosTipo = eventosTipo;
                $scope.abrangencias = abrangencias;
                $scope.papeis = papeis;
                $scope.investigadores = investigadores;
                $scope.simnao = this.simnao;
                $scope.checkingSlug = false;

                $scope.auxTipo = {
                  selected: $scope.evento.eventoTipo ? $scope.evento.eventoTipo : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxAbrangencia = {
                  selected: $scope.evento.abrangencia ? $scope.evento.abrangencia : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxPapel = {
                  selected: $scope.evento.papel ? $scope.evento.papel : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxInvestigador = {
                  selected: $scope.evento.responsavel ? $scope.evento.responsavel : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxPublicado = {
                  selected: $scope.evento.publicado ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };

                // Current year as max be able to add ano
                $scope.year = moment().format('YYYY');

                // Infinite Scroll magic
                $scope.addMoreItems = (infiniteScroll) => {
                  infiniteScroll.currentItems += infiniteScroll.numToAdd;
                };

                $scope.updateSlug = () => {
                  $scope.evento.slug = this.EventoService.stringToSlug($scope.evento.designacao);
                };

                $scope.ok = () => {
                  if (!this.EventoService.isValidURL($scope.evento.www)) {
                    this.UI.addToast("Endereço Web inválido");
                    return;
                  }
                  if (!this.EventoService.isValidSlug($scope.evento.slug)) {
                    this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
                    return;
                  }
                  // Check if slug exists
                  $scope.checkingSlug = true;
                  this.EventoService.checkExistingSlug($scope.evento.slug, this.data.id).then((exists) => {
                    $scope.checkingSlug = false;
                    if (exists) {
                      this.UI.addToast("Este slug já existe para outro evento");
                    } else {
                      $dialog.close($scope);
                    }
                  }).catch(err => {
                    $scope.checkingSlug = false;
                    this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
                    console.log(err);
                  });

                };

                $scope.cancel = () => $scope.$dismiss('cancel');
              }]
            };

            this.UI.showDialog(options).then(res => {
              this.loaded = false;
              if (res) {
                this.data.designacao = res.evento.designacao;
                this.data.local = res.evento.local;
                this.data.ano = res.evento.ano;
                this.data.www = res.evento.www;
                this.data.numParticipantes = res.evento.numParticipantes;
                this.data.slug = res.evento.slug;
                this.data.publicado = res.auxPublicado.selected.value;

                this.data.eventoTipo = res.auxTipo.selected;
                this.data.eventoTipoId = res.auxTipo.selected.id;
                this.data.abrangencia = res.auxAbrangencia.selected;
                this.data.abrangenciaId = res.auxAbrangencia.selected.id;
                this.data.papel = res.auxPapel.selected;
                this.data.papelId = res.auxPapel.selected.id;
                this.data.responsavel = res.auxInvestigador.selected;
                this.data.responsavelId = res.auxInvestigador.selected.id;

                this.data.atualizadoPorId = this.user.id;
                this.data.atualizadoa = moment().format();

                this.Evento.upsert(this.data).$promise.then((res) => {
                  this.UI.addToast("Dados atualizados com sucesso");
                  this.loadData();
                }).catch((error) => {
                  console.log(error);
                  this.UI.showAlert("Erro ao atualizar evento. Verifique a ligação");
                  this.loaded = true;
                });
              }
            });
          }).catch((error) => {
            wait.close();
            console.log(error);
            this.UI.addToast("Não foi possível ler Tipos de Evento. Verifique a ligação");
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Abrangências. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Papéis ISR. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  // Edit yes/no with extra data
  editInformacao = () => {
    let options = {
      size: 'lg',
      template: require('./informacao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Adicional";
        $scope.evento = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxIncludeDiscussion = {
          selected: $scope.evento.includeDiscussion ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxInvolvingCivilSociety = {
          selected: $scope.evento.involvingCivilSociety ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxPromotingTeamBuilding = {
          selected: $scope.evento.promotingTeamBuilding ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.data.observacoes = res.evento.observacoes || null;
        // Update bool values
        this.data.includeDiscussion = res.auxIncludeDiscussion.selected.value;
        this.data.involvingCivilSociety = res.auxInvolvingCivilSociety.selected.value;
        this.data.promotingTeamBuilding = res.auxPromotingTeamBuilding.selected.value;
        // Remove text if bool values are false
        if (!this.data.includeDiscussion) this.data.includeDiscussionText = null;
        else this.data.includeDiscussionText = res.evento.includeDiscussionText;
        if (!this.data.involvingCivilSociety) this.data.involvingCivilSocietyText = null;
        else this.data.involvingCivilSocietyText = res.evento.involvingCivilSocietyText;
        if (!this.data.promotingTeamBuilding) this.data.promotingTeamBuildingText = null;
        else this.data.promotingTeamBuildingText = res.evento.promotingTeamBuildingText;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Evento.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar evento. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  // Multiple data
  // Organizacao
  organizacaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let organizador = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      organizador = angular.copy(data);
      auxInvestigadorSelection = organizador.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.organizacao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Membro de Organização ISR";
          scope.organizador = organizador;
          scope.investigadores = investigadores;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo organizador para evento
  addOrganizador = () => {
    this.organizacaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.organizador) {
          this.organizadoresLoading = true;
          let item = angular.copy(ok.organizador);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);
          // Check if organizador is already there before creating
          this.EventoService.usedPartialDataForModel({eventoId: this.id, investigadorId: item.investigadorId}, this.EventoOrganizacao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Organizador já existe");
              this.organizadoresLoading = false;
            } else { // Create it
              this.EventoService.createMultipleData(this.EventoOrganizacao, [item], this.id, 'eventoId').then((x) => {
                this.UI.addToast("Organizador adicionado com sucesso");
                this.getOrganizadoresForEvento();
              }).catch(error => {
                this.organizadoresLoading = false;
                this.UI.addToast("Erro ao inserir organizador. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.organizadoresLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete organizador
  confirmDeleteOrganizador = (x) => {
    let title = "Eliminar Organizador";
    let warning = "Tem a certeza que pretende remover este organizador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeOrganizador(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeOrganizador = (x) => {
    this.organizadoresLoading = true;
    // Find again organizador to delete so we can update it
    this.EventoOrganizacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((organizadorToRemove) => {
      // Only for mandatory existing multiple data
      this.EventoOrganizacao.count({
        fields: {id: true},
        where: {
          eventoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other organizador still remaining

          // Remove data
          this.EventoOrganizacao.deleteById({
            id: organizadorToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Organizador removido com sucesso");
            this.getOrganizadoresForEvento();
          });

        } else { // No other organizador exist, can't remove
          this.organizadoresLoading = false;
          this.UI.showAlert("Não foi possível apagar o organizador porque tem que haver pelo menos 1 organizador ISR para o evento");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar evento. Verifique a ligação");
        this.getOrganizadoresForEvento();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar organizador. Verifique se ainda existe.");
      this.getOrganizadoresForEvento();
    });
  };

  getOrganizadoresForEvento = () => {
    this.organizadoresLoading = true;
    let whereLiteral = {
      'EventoOrganizacao.eventoId': this.id
    };
    let where = {};
    Object.keys(this.optOrganizacao.filter).forEach(f => {
      if (this.optOrganizacao.filter[f])
        where[f] = this.optOrganizacao.filter[f];
    });
    this.EventoOrganizacao.table({
      params: {
        fields: [
          'EventoOrganizacao.id as id',
          'EventoOrganizacao.eventoId as eventoId',
          'EventoOrganizacao.investigadorId as investigadorId',
          'EventoOrganizacao.dataCriacao as dataCriacao',
          'EventoOrganizacao.atualizadoa as atualizadoa',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['EventoOrganizacao', 'User', 'User', 'Investigador'],
        references: [undefined, 'EventoOrganizacao.criadoPorId', 'EventoOrganizacao.atualizadoPorId', 'EventoOrganizacao.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optOrganizacao.order,
        sort: this.optOrganizacao.sort,
        limit: this.optOrganizacao.items,
        skip: (this.optOrganizacao.page - 1) * this.optOrganizacao.items,
      }
    }).$promise.then(res => {
      let page = this.optOrganizacao.page;
      let items = this.optOrganizacao.items;

      let total = res.count;

      this.optOrganizacao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optOrganizacao.start - 1 + items) >= total) {
        this.optOrganizacao.end = total;
      } else {
        this.optOrganizacao.end = Number.parseInt(this.optOrganizacao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.organizadores = res.data;
      this.optOrganizacao.total = total;
      this.organizadoresLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler organização. Verifique a ligação");
    });
  };

  organizadorSort = keyname => {
    if (this.optOrganizacao.order === keyname)
      this.optOrganizacao.page = 1;
    this.optOrganizacao.order = keyname;
    this.optOrganizacao.sort = this.optOrganizacao.sort === 'asc' ? 'desc' : 'asc';
    this.getOrganizadoresForEvento();
  };

  organizadorItem = val => {
    this.optOrganizacao.items = val;
    this.optOrganizacao.page = 1;
    this.getOrganizadoresForEvento();
  };

  organizadorPage = sum => {
    this.optOrganizacao.page += sum;
    if (this.optOrganizacao.page < 1)
      this.optOrganizacao.page = 1;
    if (this.optOrganizacao.page > Math.ceil(this.optOrganizacao.total / this.optOrganizacao.items))
      this.optOrganizacao.page = Math.ceil(this.optOrganizacao.total / this.optOrganizacao.items);
    this.getOrganizadoresForEvento();
  };

  viewOrganizador = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./organizacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Impactos
  // Edit Impacto Ambiental, Económico, Social
  editImpactos = () => {
    let options = {
      size: 'lg',
      template: require('./impactos.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Impacto Ambiental, Económico, Social";
        $scope.impacto = angular.copy(this.data.impacto);
        $scope.simnao = this.simnao;

        $scope.auxImpactoAmbiental = {
          selected: $scope.impacto.ambiental ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoEconomico = {
          selected: $scope.impacto.economico ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoSocial = {
          selected: $scope.impacto.social ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoPolicyInfluence = {
          selected: $scope.impacto.policyInfluence ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      // Ambiental
      if (ok.auxImpactoAmbiental.selected.value) {
        this.data.impacto.ambiental = ok.impacto.ambiental;
      } else {
        this.data.impacto.ambiental = null;
      }
      // Económico
      if (ok.auxImpactoEconomico.selected.value) {
        this.data.impacto.economico = ok.impacto.economico;
      } else {
        this.data.impacto.economico = null;
      }
      // Social
      if (ok.auxImpactoSocial.selected.value) {
        this.data.impacto.social = ok.impacto.social;
      } else {
        this.data.impacto.social = null;
      }
      // Policy influence
      if (ok.auxImpactoPolicyInfluence.selected.value) {
        this.data.impacto.policyInfluence = ok.impacto.policyInfluence;
      } else {
        this.data.impacto.policyInfluence = null;
      }

      this.data.impacto.observacoes = ok.impacto.observacoes || null;

      this.data.impacto.criadoPorId = this.user.id;
      this.data.impacto.dataCriacao = moment().format();

      this.Impacto.upsert(this.data.impacto).$promise.then(() => {
        this.UI.addToast("Impactos atualizados com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar impactos. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  //Impactos ODS
  impactosOdsModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let ods = {};
    let auxOdsSelection = undefined;
    if (edit && data != null) {
      ods = angular.copy(data);
      auxOdsSelection = ods.ods;
    }
    let wait = this.UI.showWaiting();
    this.Ods.find({}).$promise.then((externalData) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/impacto.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Impacto ODS";
          scope.ods = ods;
          scope.externalData = externalData;
          scope.tipo = 'ODS';

          scope.auxOds = {
            selected: auxOdsSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Impactos ODS. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo ODS para impacto
  addImpactoOds = () => {
    this.impactosOdsModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxOds && ok.ods) {
          this.impactosOdsLoading = true;
          let item = angular.copy(ok.ods);
          item.odsId = ok.auxOds.selected.id;
          item.ods = angular.copy(ok.auxOds.selected);
          // Check if ODS is already there before creating
          this.EventoService.usedPartialDataForModel({impactoId: this.data.impactoId, odsId: item.odsId}, this.ImpactoOds).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Impacto ODS já existe");
              this.impactosOdsLoading = false;
            } else { // Create it
              this.EventoService.createMultipleData(this.ImpactoOds, [item], this.data.impactoId, 'impactoId').then(() => {
                this.UI.addToast("ODS adicionado com sucesso");
                this.getImpactosOdsForImpacto();
              }).catch(error => {
                this.impactosOdsLoading = false;
                this.UI.addToast("Erro ao inserir ODS. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.impactosOdsLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete ODS
  confirmDeleteImpactoOds = (x) => {
    let title = "Eliminar Impacto ODS";
    let warning = "Tem a certeza que pretende remover este impacto ODS?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeImpactoOds(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeImpactoOds = (x) => {
    this.impactosOdsLoading = true;
    // Find again impacto ods to delete, so we can update it
    this.ImpactoOds.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((impactoOdsToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ImpactoOds.deleteById({
        id: impactoOdsToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Impacto ODS removido com sucesso");
        this.getImpactosOdsForImpacto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar impacto ODS. Verifique se ainda existe.");
      this.getImpactosOdsForImpacto();
    });
  };

  getImpactosOdsForImpacto = () => {
    this.impactosOdsLoading = true;
    let whereLiteral = {
      'ImpactoOds.impactoId': this.data.impactoId
    };
    let where = {};
    Object.keys(this.optImpactosOds.filter).forEach(f => {
      if (this.optImpactosOds.filter[f])
        where[f] = this.optImpactosOds.filter[f];
    });
    this.ImpactoOds.table({
      params: {
        fields: [
          'ImpactoOds.id as id',
          'ImpactoOds.impactoId as impactoId',
          'ImpactoOds.odsId as odsId',
          'ImpactoOds.dataCriacao as dataCriacao',
          'User.name as criadoPor',
          'Ods.id as auxOdsId',
          'Ods.designacao as auxOdsDesignacao'
        ],
        from: ['ImpactoOds', 'User', 'Ods'],
        references: [undefined, 'ImpactoOds.criadoPorId', 'ImpactoOds.odsId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optImpactosOds.order,
        sort: this.optImpactosOds.sort,
        limit: this.optImpactosOds.items,
        skip: (this.optImpactosOds.page - 1) * this.optImpactosOds.items,
      }
    }).$promise.then(res => {
      let page = this.optImpactosOds.page;
      let items = this.optImpactosOds.items;

      let total = res.count;

      this.optImpactosOds.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optImpactosOds.start - 1 + items) >= total) {
        this.optImpactosOds.end = total;
      } else {
        this.optImpactosOds.end = Number.parseInt(this.optImpactosOds.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ods = {
          id: x.auxOdsId,
          designacao: x.auxOdsDesignacao
        };
      });

      this.impactosOds = res.data;
      this.optImpactosOds.total = total;
      this.impactosOdsLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler ODS. Verifique a ligação");
    });
  };

  impactoOdsSort = keyname => {
    if (this.optImpactosOds.order === keyname)
      this.optImpactosOds.page = 1;
    this.optImpactosOds.order = keyname;
    this.optImpactosOds.sort = this.optImpactosOds.sort === 'asc' ? 'desc' : 'asc';
    this.getImpactosOdsForImpacto();
  };

  impactoOdsItem = val => {
    this.optImpactosOds.items = val;
    this.optImpactosOds.page = 1;
    this.getImpactosOdsForImpacto();
  };

  impactoOdsPage = sum => {
    this.optImpactosOds.page += sum;
    if (this.optImpactosOds.page < 1)
      this.optImpactosOds.page = 1;
    if (this.optImpactosOds.page > Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items))
      this.optImpactosOds.page = Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items);
    this.getImpactosOdsForImpacto();
  };

  viewImpactoOds = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./impacto.ods.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss');
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.EventoService.canRead('eventoRead', true, 'eventoReadAny', this.EventoService.getOrganizacaoUserId(this.data));
  canEditGeneral = () => this.EventoService.canEdit('eventoEdit', true, 'eventoEditAny', this.EventoService.getOrganizacaoUserId(this.data));

  canReadAdicional = () => this.EventoService.canRead('eventoReadAdicional', true, 'eventoReadAdicionalAny', this.EventoService.getOrganizacaoUserId(this.data));
  canEditAdicional = () => this.EventoService.canEdit('eventoEditAdicional', true, 'eventoEditAdicionalAny', this.EventoService.getOrganizacaoUserId(this.data));

  canReadOrganizacao = () => this.EventoService.canRead('eventoReadOrganizacao', true, 'eventoReadOrganizacaoAny', this.EventoService.getOrganizacaoUserId(this.data));
  canEditOrganizacao = () => this.EventoService.canEdit('eventoEditOrganizacao', true, 'eventoEditOrganizacaoAny', this.EventoService.getOrganizacaoUserId(this.data));

  canReadImpacto = () => this.EventoService.canRead('eventoReadImpacto', true, 'eventoReadImpactoAny', this.EventoService.getOrganizacaoUserId(this.data));
  canEditImpacto = () => this.EventoService.canEdit('eventoEditImpacto', true, 'eventoEditImpactoAny', this.EventoService.getOrganizacaoUserId(this.data));

}

EventoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'EventoService', 'Evento', 'EventoOrganizacao', 'EventoTipo', 'Abrangencia', 'Papel', 'Investigador', 'Impacto', 'ImpactoOds', 'Ods', 'Pais'];
